import axios from "axios";
import { API_BASE_URL } from "../../app/apiConfig";

// Use the supplied route verbatim; do not attach an existing portal session.
export const CALLBACK_PATH = "/public/callback";
const callbackClient = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
  timeout: 20000,
  withCredentials: false,
});

export function requestCallback({ fullName, phoneNumber, email, message }) {
  return callbackClient.post(CALLBACK_PATH, {
    fullName: fullName.trim(),
    phoneNumber: phoneNumber.trim(),
    email: email.trim(),
    message: message.trim(),
  });
}
